export const MIN_FORCE_REASON_LENGTH = 5;
export const MAX_FORCE_REASON_LENGTH = 500;

export function validateForceReason(reason: string): string | undefined {
    const length = reason.trim().length;
    if (length < MIN_FORCE_REASON_LENGTH) {
        return `Enter at least ${MIN_FORCE_REASON_LENGTH} characters.`;
    }
    if (length > MAX_FORCE_REASON_LENGTH) {
        return `Keep it under ${MAX_FORCE_REASON_LENGTH} characters.`;
    }
    return undefined;
}
